export default "__VITE_ASSET__BQsr4BDH__"